"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsManageService = void 0;
const Interfaces_1 = require("../Interfaces");
var OptionsManageService;
(function (OptionsManageService) {
  /**
   * @title YOL Service
   * @version 1.3.1
   * @license MIT
   * @baseUrl /options-manage
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * yol-options-manage-service [ 📜 View Changelog](/options-manage/internal/release-note)
   */
  class Api {
    constructor(url, http) {
      this.public = {
        /**
        * No description
        *
        * @tags public
        * @name GetNetworkSettings
        * @request GET:/options-manage/subscription/{subscriptionId}/network-settings
        * @secure bearerAuth
        * @response `200` `(OptionsResp)[]` Ok
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        getNetworkSettings: (subscriptionId, params = {}) => this.http.request("GET", `${this.url}/options-manage/subscription/${subscriptionId}/network-settings`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name UpdateNetworkSettings
        * @request POST:/options-manage/subscription/{subscriptionId}/update-network-settings
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_INVALID_SUBSCRIPTION" | "ERR_INVALID_OPTION" | "ERR_OPTION_IS_MANDATORY" | "ERR_OPTION_IS_ALREADY_SUBSCRIBED" | "ERR_OPTION_IS_ALREADY_UNSUBSCRIBED",
             }`
        * @response `404` `{
        error: "ERR_SUBSCRIPTION_NOT_FOUND" | "ERR_OPTION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FROM_API" | "ERR_FROM_CRM" | "ERR_CRM_TIMEOUT",
             }`
        */
        updateNetworkSettings: (subscriptionId, data, params = {}) => this.http.request("POST", `${this.url}/options-manage/subscription/${subscriptionId}/update-network-settings`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  OptionsManageService.Api = Api;
})(OptionsManageService || (exports.OptionsManageService = OptionsManageService = {}));